import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";

import DateRange from "../../Components/DateRange";
import DateFormat from "../../helpers/DateFormat";
import FormTime from "./_formTime";
import ApiClient from "../../Client";

import Loader from "../../Components/Loading";
import SelectVirtualized from "react-virtualized-select";
import Select from "react-select";
import { extendStyles } from "../../helpers/formComponent"

const mapStateToProps = ({ identity }) => ({
  identity
});

class ScheduleForm extends Component {
  state = {
    isFetched: true,
    isFetching: false,
    isUpdate: false,
    films: null,
    dateBegin: DateFormat.getEpoch(new Date()),
    dateEnd: DateFormat.getEpoch(new Date()) + 3600 * 24 * 7,
    errors: {}
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount() {
    const { id } = this.props.match.params || {};
    const queries = [];
    const { identity } = this.props;

    if (id) {
      queries.push(
        this.fetchSchedule(id).then(schedule => {
          if (
            !schedule ||
            (identity.position !== "admin" &&
              (!identity.theatreId || identity.theatreId !== schedule.theatre.id))
          ) {
            return this.props.history.replace("/page-not-found");
          }

          const { id, times, film, theatre, dateBegin, dateEnd } = schedule;
          return {
            id,
            isUpdate: true,
            times,
            film: (film && film.id) || null,
            theatre: (theatre && theatre.id) || null,
            dateBegin,
            dateEnd
          };
        })
      );
    } else {
      queries.push({ theatre: identity.theatreId || null })
    }
    if (identity.position === "admin") {
      queries.push(this.fetchTheatres().then(theatres => ({ theatres })));
    }
    queries.push(this.fetchFilms().then(films => ({ films })));
    this.setState({ isFetched: false, isFetching: true });

    Promise.all(queries).then(results => {
      const state = results.reduce((prev, res) => Object.assign(prev, res), {
        isFetched: true,
        isFetching: false
      });
      !this.isCancelled && this.setState(state);
    });
  }

  getAuthCookie() {
    const { cookies } = this.props;
    return cookies.get(process.env.REACT_APP_IDENTITY_COOKIE) || "";
  }

  fetchFilms() {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(`{films{id title value:id label:title}}`)
      .then(({ films }) => films);
  }

  fetchTheatres() {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(`{theatres{id name value:id label:name}}`)
      .then(({ theatres }) => theatres);
  }

  fetchSchedule(id) {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(
        `query($id:ID!) { schedule(where:{id:$id}) { id times dateBegin dateEnd film{id} theatre{id} } }`,
        { id }
      )
      .then(({ schedule }) => schedule);
  }

  findOptionByValue(list, value) {
    if (list && value) {
      for (let idx = 0; idx < list.length; idx++) {
        if (list[idx].value === value) {
          return list[idx];
        }
      }
    }
    return null;
  }

  filmOnChange = film => {
    this.setState({ film: film.value || null }, () => this.validate("film"));
  };

  theatreOnChange = theatre => {
    this.setState({ theatre: theatre.value || null }, () =>
      this.validate("theatre")
    );
  };

  getRange() {
    const { dateBegin, dateEnd } = this.state;
    return {
      dateBegin: dateBegin ? DateFormat.dateFromEpoch(dateBegin) : null,
      dateEnd: dateEnd ? DateFormat.dateFromEpoch(dateEnd) : null
    };
  }

  dateRangeOnChange = ({ startDate, endDate }) => {
    this.setState(
      {
        dateBegin: startDate ? DateFormat.getEpoch(startDate) : null,
        dateEnd: endDate ? DateFormat.getEpoch(endDate) : null
      },
      () => this.validate("date")
    );
  };

  addTime = time => {
    const { times } = this.state;
    if (!(times && times.includes(time))) {
      this.setState({ times: [...(times || []), time] }, () =>
        this.validate("times")
      );
    }
  };

  removeTime = time => {
    const { times } = this.state;
    if (times && times.includes(time)) {
      const newTimes = [...times];
      newTimes.splice(newTimes.indexOf(time), 1);
      this.setState({ times: newTimes });
    }
  };

  createRequest(data) {
    return ApiClient.setHeader("authKey", this.getAuthCookie())
      .request(
        `mutation($data: ScheduleCreateInput!){
        schedule:createSchedule(data: $data) {
          id
        }
      }`,
        { data }
      )
      .then(({ schedule }) => schedule);
  }

  updateRequest(id, data) {
    return ApiClient.setHeader("authKey", this.getAuthCookie())
      .request(
        `mutation($data:ScheduleUpdateInput! $id: ID!){
        schedule:updateSchedule(data: $data where:{ id: $id }) {
          id
        }
      }`,
        { id, data }
      )
      .then(({ schedule }) => schedule);
  }

  setError(name, message) {
    this.addErrors({ [name]: message });
  }

  getError(name) {
    return this.state.errors[name] || null;
  }

  addErrors(errors) {
    this.setState({ errors: { ...this.state.errors, ...errors } });
  }

  validate(attributes = null, refresh = true) {
    const errors = refresh ? {} : this.state.errors;
    const { film, theatre, times, dateBegin, dateEnd } = this.state;
    if (attributes && !Array.isArray(attributes)) {
      attributes = [attributes];
    }
    if (
      (!attributes || attributes.includes("times")) &&
      !(times && times.length)
    ) {
      errors["times"] =
        "You must select at least one value for the 'time' field";
    }
    if ((!attributes || attributes.includes("film")) && !film) {
      errors["film"] = "Field 'film' is required";
    }
    if ((!attributes || attributes.includes("theatre")) && !theatre) {
      errors["theatre"] = "Theatre must be a filled for schedule";
    }
    if (!attributes || attributes.includes("date")) {
      if (!dateBegin) {
        errors["date"] = "Start date must be filled";
      } else if (!dateEnd) {
        errors["date"] = "End date must be filled";
      } else if (dateEnd < dateBegin) {
        errors["date"] = "End date cannot be lt. start date";
      }
    }
    !attributes
      ? this.setState({ errors })
      : this.addErrors(
        attributes.reduce(
          (prev, attribute) =>
            Object.assign(prev, { [attribute]: errors[attribute] || null }),
          {}
        )
      );
    return !Object.entries(errors).length;
  }

  hasErrors(name = null) {
    const { errors } = this.state;
    return !!(name ? errors[name] : Object.entries(errors).length);
  }

  submitClick = () => {
    if (this.validate()) {
      const { id, film, theatre, times, dateBegin, dateEnd } = this.state;
      const { isUpdate } = this.state;
      const data = {
        film: (film && { connect: { id: film } }) || null,
        theatre: (theatre && { connect: { id: theatre } }) || null,
        times: { set: times || [] },
        dateBegin,
        dateEnd
      };
      (isUpdate ? this.updateRequest(id, data) : this.createRequest(data)).then(
        data => {
          if (data && data.id) {
            if (isUpdate) {
              this.props.history.goBack();
            } else {
              this.props.history.push(`/schedule/update/${data.id}`);
            }
          }
        }
      );
    }
  };

  cancelClick = () => {
    this.props.history.goBack();
  };

  renderError(name) {
    if (this.hasErrors(name)) {
      return <span className="text-danger">{this.getError(name)}</span>;
    }
    return "";
  }

  render() {
    const {
      isUpdate,
      films,
      theatres,
      film,
      theatre,
      times,
      isFetched,
      isFetching
    } = this.state;
    const { identity } = this.props;
    const { dateBegin, dateEnd } = this.getRange();

    if (!isFetched && isFetching) {
      return <Loader loading />;
    }

    return (
      <Fragment>
        <h1 className="office-h1">
          {isUpdate ? "Редактирование расписания" : "Добавить расписание"}
        </h1>
        <div className="office-filters">
          <div className="custom-select__group office-filters__half">
            <label htmlFor="schedule-form-film">Фильм</label>
            <br />
            <SelectVirtualized
              selectComponent={Select}
              id="schedule-form-film"
              onChange={this.filmOnChange}
              options={films || []}
              value={this.findOptionByValue(films, film)}
              className="selectReact"
              classNamePrefix="selectReact"
              placeholder="Начните вводить название фильма"
              styles={extendStyles()}
            />
            {this.renderError("film")}
          </div>
          <div className="custom-datepicker__group office-filters__half">
            <label htmlFor="schedule-form-date">День начала/окончания</label>
            <br />
            <DateRange
              input
              id="schedule-form-date"
              dateBegin={dateBegin}
              dateEnd={dateEnd}
              onChange={this.dateRangeOnChange}
              className="custom-datepicker__input"
            />
            <img
              src="/images/icon-calendar.png"
              alt=""
              className="custom-datepicker__icon"
            />
            {this.renderError("date")}
          </div>
          {identity.position === "admin" ? (
            <div className="office-filters__full">
              <label htmlFor="schedule-form-theatre">Кинотеатр</label>
              <br />
              <SelectVirtualized
                selectComponent={Select}
                id="schedule-form-theatre"
                onChange={this.theatreOnChange}
                options={theatres || []}
                value={this.findOptionByValue(theatres, theatre)}
                className="selectReact"
                classNamePrefix="selectReact"
                placeholder="Начните вводить название кинотеатра"
                styles={extendStyles()}
              />
            </div>
          ) : (
              ""
            )}
          {this.renderError("theatre")}
        </div>
        <FormTime
          times={times || []}
          add={this.addTime}
          remove={this.removeTime}
        />
        {this.renderError("times")}
        <hr />
        <div className="office-add-session__footer">
          <button className="btn-border-white" onClick={this.cancelClick}>
            Отмена
          </button>
          <button className="btn-gradient" onClick={this.submitClick}>
            Сохранить
          </button>
        </div>
      </Fragment>
    );
  }
}

export default withCookies(withRouter(connect(mapStateToProps)(ScheduleForm)));



// WEBPACK FOOTER //
// ./src/containers/schedule/form.jsx